import { computed } from 'vue'
import { useCoinPriceAPIStore, useNFTAPIStore } from '@/stores'
import {
  type Maybe,
  BaseCoin,
  type BaseCoinPrice,
  type CoreNetwork,
} from '@/types'
import type { ICoinInfo } from '@/types/api'

// V2에서 feeType은 string
type CoinFeeType = string

export class Coin extends BaseCoin {
  id: number
  name: string
  symbol: string
  network: string
  coreNetwork: CoreNetwork
  iconUrl: string
  chainId?: string
  decimals: number
  isTestnet: boolean
  cmkId?: number
  coinGeckoId?: string
  explorerUrl?: string
  explorerAddress?: string
  explorerTransaction?: string
  explorerContract?: string
  color?: string
  priceInfo: Maybe<BaseCoinPrice>
  coin: undefined
  supportNft?: boolean
  feeType: CoinFeeType
  property?: Record<string, unknown>

  constructor(coinInfo: ICoinInfo) {
    super()
    this.id = coinInfo.id
    this.name = coinInfo.name
    this.symbol = coinInfo.symbol
    /** 사용자에게 보여지면 안되는 key 값 */
    this.network = coinInfo.network
    this.coreNetwork = coinInfo.coreNetwork as CoreNetwork
    this.iconUrl = coinInfo.iconUrl || ''
    this.chainId = coinInfo.chainId as string | undefined
    this.decimals = coinInfo.decimals ?? 0
    this.isTestnet = Boolean(coinInfo.isTestnet)
    this.cmkId = coinInfo.cmkId as number | undefined
    this.coinGeckoId = coinInfo.coinGeckoId as string | undefined
    this.explorerUrl = coinInfo.explorerUrl
    this.explorerAddress = coinInfo.explorerAddress as string | undefined
    this.explorerTransaction = coinInfo.explorerTransaction as
      | string
      | undefined
    this.explorerContract = coinInfo.explorerContract as string | undefined
    this.color = coinInfo.color
    this.feeType = coinInfo.feeType
    this.property = coinInfo.property

    const coinPriceAPIStore = useCoinPriceAPIStore()
    const computedPriceInfo = computed(() => {
      if (!this.coinGeckoId) return
      return coinPriceAPIStore.getCoinPrice(this.coinGeckoId)
    })
    Object.defineProperty(this, 'priceInfo', {
      get(): Maybe<BaseCoinPrice> {
        return computedPriceInfo.value
      },
    })

    const nftAPIStore = useNFTAPIStore()
    const computedNftInfo = computed(() => {
      if (
        nftAPIStore.nftSupportedList?.find(
          (ele: any) =>
            ele?.coinId === this.id || ele?.network === this.network,
        )
      ) {
        return true
      } else {
        return false
      }
    })
    Object.defineProperty(this, 'supportNft', {
      get(): Boolean {
        return computedNftInfo.value
      },
    })
  }

  get networkSymbol() {
    return this.symbol
  }
  get networkIcon() {
    return this.iconUrl
  }
  get networkName() {
    return this.name
  }
  get networkDecimals() {
    return this.decimals
  }
  get networkPriceInfo() {
    return this.priceInfo
  }
}
